import _AOEffect from "../ao/AOEffect";
import _AOPass from "../ao/AOPass";
import _hbao from "./shader/hbao";
import _hbao_utils from "./shader/hbao_utils";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HBAOEffect = void 0;
const AOEffect_1 = _AOEffect;
const AOPass_1 = _AOPass;
const hbao_1 = _hbao;
const hbao_utils_1 = _hbao_utils;
const finalFragmentShader = hbao_1.hbao.replace("#include <hbao_utils>", hbao_utils_1.hbao_utils);
class HBAOPass extends AOPass_1.AOPass {
  // #region Constructors (1)
  constructor(camera, scene) {
    super(camera, scene, finalFragmentShader);
  }
}
class HBAOEffect extends AOEffect_1.AOEffect {
  // #endregion Properties (1)
  // #region Constructors (1)
  constructor(composer, camera, scene, options = AOEffect_1.AOEffect.DefaultOptions) {
    super(composer, camera, scene, new HBAOPass(camera, scene), Object.assign(Object.assign(Object.assign({}, AOEffect_1.AOEffect.DefaultOptions), HBAOEffect.DefaultOptions), options));
    // #region Properties (1)
    this.lastSize = {
      width: 0,
      height: 0,
      resolutionScale: 0
    };
  }
}
exports.HBAOEffect = HBAOEffect;
//# sourceMappingURL=HBAOEffect.js.map
export default exports;